import * as React from "react";
import NavBar from "../../components/NavBar";
import {useTranslation} from "react-i18next";
import {Backdrop, CircularProgress, Divider, Pagination, PaginationItem} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";
import {ArrowBack, ArrowForward, SearchOutlined} from "@mui/icons-material";
import {setLoading} from "../../redux/loading/actions";
import {convertDate} from "../../assets/js/main";
import {ThemeContext} from "../../App";


export default function MyRequests() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()
  const {fetchData} = HandleFetchData()
  const theme = React.useContext(ThemeContext)

  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const [listRequest, setListRequest] = React.useState(null)
  const [listStatus, setListStatus] = React.useState(null)
  const [status, setStatus] = React.useState("")
  const [activeFilter, setActiveFilter] = React.useState(1)
  const [pageNum, setPageNum] = React.useState(1)
  const pageSize = 10
  const listFilter = [
    {
      title: t("myRequests.t3"),
      id: 1
    },
    {
      title: t("myRequests.t4"),
      id: 2
    },
    {
      title: t("myRequests.t5"),
      id: 3
    },
    {
      title: t("myRequests.t6"),
      id: 4
    },
  ]
  const userInfo = JSON.parse(localStorage.getItem('info-user'))

  React.useEffect(() => {
    handleFetchMethods(activeFilter)
  }, [status])


  const handleFetchMethods = async (e) => {
    e === 1 ? handleGetWithdrawalRequests() :
       e === 2 ? handleGetCancellationRequests() :
          e === 3 ? handleGetAgentRequests(false) : handleGetAgentRequests(true)
  }

  const handleGetAgentRequests = async (e) => {
    e ? await handleGetShopStatus() : await handleGetAgentStatus()

    dispatch(setLoading(true))
    let fetch = await fetchData('api.panel', 'GET', '/v1/Agents', '', "application/json", {
      "isShop": e,
      "Mobile": userInfo?.Mobile,
      "PageIndex": pageNum,
      "PageSize": pageSize
    }, 'postex', "HiBackOfficePostexAdmin@1402")

    if (fetch?.success) {
      setListRequest(fetch)
    } else {
      setListRequest(null)
    }

    dispatch(setLoading(false))
  }

  const handleGetAgentStatus = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('api.panel', 'GET', '/v1/Constants/AgentStatuses', '', "application/json", '', 'postex', "HiBackOfficePostexAdmin@1402")

    if (fetch?.success) {
      setListStatus(fetch)
    } else {
      setListStatus(null)
    }
    dispatch(setLoading(false))
  }

  const handleGetShopStatus = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('api.panel', 'GET', '/v1/Constants/ShopStatuses', '', "application/json", '', 'postex', "HiBackOfficePostexAdmin@1402")

    if (fetch?.success) {
      setListStatus(fetch)
    } else {
      setListStatus(null)
    }
    dispatch(setLoading(false))
  }

  const handleGetCancellationRequests = async () => {
    await handleGetCancellationStatus()
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'GET', '/v1/OrderCancellation', '', "application/json", {
      "MobileNumber": userInfo?.Mobile,
      "StatusCode": status,
      "PageIndex": pageNum,
      "PageSize": pageSize
    }, 'postex', "HiTicketPostexAdmin@1402")

    if (fetch?.success) {
      setListRequest(fetch)
    } else {
      setListRequest(null)
    }
    dispatch(setLoading(false))
  }

  const handleGetCancellationStatus = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'GET', '/v1/Constants/OrderCancellationStatuses', '', "application/json", '', 'postex', "HiTicketPostexAdmin@1402")

    if (fetch?.success) {
      setListStatus(fetch)
    } else {
      setListStatus(null)
    }
    dispatch(setLoading(false))
  }

  const handleGetWithdrawalRequests = async () => {
    await handleGetWithdrawalStatus()
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'GET', '/v1/Withdrawal', '', "application/json", {
      "MobileNumber": userInfo?.Mobile,
      "StatusCode": status,
      "PageIndex": pageNum,
      "PageSize": pageSize
    }, 'postex', "HiTicketPostexAdmin@1402")

    if (fetch?.success) {
      setListRequest(fetch)
    } else {
      setListRequest(null)
    }
    dispatch(setLoading(false))
  }

  const handleGetWithdrawalStatus = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'GET', '/v1/Constants/WithdrawalStatusStatuses', '', "application/json", '', 'postex', "HiTicketPostexAdmin@1402")

    if (fetch?.success) {
      setListStatus(fetch)
    } else {
      setListStatus(null)
    }
    dispatch(setLoading(false))
  }


  const handleSearch = (i) => {
    // if (i) {
    //   let search = []
    //   listRequest?.data?.map(item => {
    //     console.log(listRequest?.data?.fullName?.includes(i))
    //        if (activeFilter === 1) {
    //          search = listRequest?.data?.ticketId?.includes(i)
    //        } else if (activeFilter === 2) {
    //          search = listRequest?.data?.orderNo?.includes(i)
    //        }
    //      }
    //   )
    //   console.log('search', search)
    //   setListRequest(search)
    //   // setFAQSearch(search)
    // } else {
    //   handleFetchMethods(activeFilter)
    // }
  }

  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       {/*کامپوننت نوبار*/}
       <div className="d-block d-lg-none">
         <NavBar blue back/>
       </div>

       <div className="container">
         <div className="myRequestsPage desktopSection">
           <div className="titlePage">
             <h4 className="titleSection mb-4">{t("myRequests.t1")}</h4>

             {/*<div>*/}
             {/*  <input type="text" name="search" placeholder={t("myRequests.t2")} id="search" onChange={(e) => handleSearch(e.target.value)}/>*/}
             {/*  <SearchOutlined/>*/}
             {/*</div>*/}
           </div>

           <div className="filter">
             <div className="right-item">
               {listFilter?.map(item =>
                  <button type="button" className={activeFilter === item?.id ? "active" : ""}
                          onClick={() => {
                            setActiveFilter(item?.id)
                            handleFetchMethods(item?.id)
                            setStatus("")
                          }}>
                    {item?.title}
                  </button>)
               }

             </div>

             <div className="left-item">
               <select aria-label="Default select example" id="filter" defaultValue={status} onChange={(event) => setStatus(event?.target?.value)}>
                 <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                 {listStatus?.data?.map(item => <option value={item?.code} key={item?.code}>{item?.title}</option> )}
               </select>
             </div>
           </div>

           <Divider/>


           <div className="items">
             <div className="row">
               {listRequest?.data?.map(item => <div className="col-12 col-lg-6 mb-4" key={item?.id}>
                 <div className="item">
                   <div className="desc">
                     {activeFilter === 2 ?
                        <p>{t("myRequests.t11") + ": " + item?.orderNo}</p>
                        :
                        activeFilter === 1 ?
                           <p>{t("myRequests.t7") + ": " + item?.ticketId}</p>
                           :
                           <p>{t("myRequests.t10") + ": " + item?.ticketId}</p>

                     }
                     <span>|</span>
                     <p>{t("myRequests.t8") + ": " + (item?.createdOn ? convertDate(item?.createdOn) : "-")}</p>
                   </div>

                   <div className="btnGroup_yellow m-0">
                     <button type="button" className="btnFill m-0 btn btn-secondary" disabled>
                       <span>{t("myRequests.t9")}</span>
                     </button>
                   </div>

                 </div>
               </div>)}
             </div>


             {
               !listRequest?.data?.length && <div className="notFindMessage">
                 <img src={require('./../../assets/img/vector/1.png')} alt="vector"/>
                 <p>{t("error.t2")}</p>
               </div>
             }
           </div>

           {
             listRequest?.totalCount > 0 &&
             <div className="paginate">
               <Pagination
                  count={listRequest?.totalCount}
                  page={pageNum}
                  onChange={(event, value) => setPageNum(value)}
                  renderItem={(item) => (
                     <PaginationItem
                        slots={{previous: ArrowBack, next: ArrowForward}}
                        {...item}
                     />
                  )}
               />
             </div>
           }


         </div>
       </div>

     </>
  )
}
